import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import { extractSelectedTicketIdFromState, getCurrentBlockingAlert } from 'extractFromState';
import { toggleAlertShowHide } from 'actions/searchActions';
import AlertMetadata from 'components/common/AlertOrMacroMetadata/AlertOrMacroMetadata';
import { markBusinessAlertAsRead } from 'api/businessAlerts';
import { alertsTypesMap } from 'constants/alerts';
import { getIconForAlert, parseSanitizedAlertContent } from 'util/alertUtil';
import { setBlockingAlertViewed } from 'actions/tools/ToolActions';
import {
  BlueBar,
  HeaderSection,
  TitleContainer,
  Title,
  AlertTitle,
  AlertButton,
} from 'components/tools/alerts/Alerts.styles';
import {
  Container,
  Section,
  BlockingAlertHeader,
  BlockingAlertContainer,
  BlockingAlertContentContainer,
  BlockingAlertContent,
  ButtonContainer,
  ButtonSection,
  BlockingAlertNote,
} from './BlockingAlert.styles';

class BlockingAlert extends React.Component {
  handleMarkAsRead(alert) {
    if (!alert.read) {
      // updates DB
      markBusinessAlertAsRead(alert.id);
    }
    // updates redux
    this.props.setBlockingAlertViewed(alert.id);
    this.props.toggleAlertShowHide(alert.id);
  }

  getAlertTypeLabel() {
    const { alert } = this.props;

    return get(alertsTypesMap, `[${alert.type}].label`, '');
  }

  renderAlert() {
    const { alert } = this.props;

    return (
      <BlockingAlertContainer>
        <BlockingAlertHeader>
          <AlertMetadata resource={alert} theme="dark" />
          <AlertTitle>{alert.title}</AlertTitle>
        </BlockingAlertHeader>
        {alert.note && (
          <BlockingAlertHeader>
            <BlockingAlertNote>{alert.note}</BlockingAlertNote>
          </BlockingAlertHeader>
        )}
        <BlockingAlertContentContainer>
          <BlockingAlertContent {...parseSanitizedAlertContent(alert.content)} />
          <ButtonContainer>
            <ButtonSection>
              <p>All good? If yes, click next</p>
              <AlertButton onClick={() => this.handleMarkAsRead(alert)}>ACKNOWLEDGE &amp; CONTINUE</AlertButton>
            </ButtonSection>
          </ButtonContainer>
        </BlockingAlertContentContainer>
        <BlueBar />
      </BlockingAlertContainer>
    );
  }

  render() {
    const { alert } = this.props;

    return (
      <Container>
        <HeaderSection>
          <TitleContainer>
            <img src={getIconForAlert(alert.type)} alt={alert.type} />
            <Title>{`Please carefully review the following ${this.getAlertTypeLabel().toLowerCase()} alert`}</Title>
          </TitleContainer>
        </HeaderSection>
        <Section>
          <BlueBar />
          {this.renderAlert()}
        </Section>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  simplrAccountId: extractSelectedTicketIdFromState(state),
  alert: getCurrentBlockingAlert(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleAlertShowHide,
      setBlockingAlertViewed,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BlockingAlert);
